module.exports = __webpack_public_path__ + "static/img/egg_b_07.4e613bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_07.png
// module id = /CjO
// module chunks = 1